import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { PropertyValuationService } from '../shared/services/property-valuation.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';


export interface Valuations {
  status: string;
  property: Properties
}

export interface Properties {
  image_url: string;
  propName: string;
  propDescription: string;
}

 const ELEMENT_DATA:Valuations[] = [];

@Component({
  selector: 'app-valuations',
  templateUrl: './valuations.component.html',
  styleUrls: ['./valuations.component.css']
})
export class ValuationsComponent implements OnInit {
  displayedColumns: string[] = ['image_url', 'propName', 'status', 'propDescription'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public pageName = "Valuations";
  public propertiesData: any = [];
  
  public isLoading = true;
  public isResults: boolean = true;
  public viewValuations: boolean = true;
  public imageBaseUrl = "https://ganisponsormarket-all-purpose.s3.amazonaws.com/";
  userGroup: any;
  state: any;
  openSuccessModal: boolean = false;
  valuationSearchText: any;
  searchText: any;
  displaySearchText: any = "";
  categories: { id: number; value: string; isSelected: boolean; }[];
  queryArr: any = [];
  owner_id: any;
  isSorting: boolean = false;
  filters: any = [];
  searching: boolean;
  resultsValue: any;
  searchResults: boolean;
  sortedData: [];

  constructor(private router: Router, private valuationService: PropertyValuationService, private route: ActivatedRoute) {
    this.getEvaluations("sponsors");
  }

  ngOnInit(): void {
    this.getEvaluations("sponsors");

    this.categories = [
      { id: 1, value: 'SUBMITTED', isSelected: false },
      { id: 2, value: 'RECEIVED', isSelected: false },
      { id: 3, value: 'VALUATED', isSelected: false }
    ];

    this.state = history.state;
    if (this.state.success) {
      this.openSuccessModal = true;
    } else {
      this.openSuccessModal = false;
    }

    this.viewValuations = true;
    this.isLoading = true;

    Auth.currentAuthenticatedUser()
      .then((user) => {
        this.owner_id = user.signInUserSession.accessToken.payload.sub;

        this.userGroup = user.signInUserSession.accessToken.payload['cognito:groups'][0];
        this.getEvaluations(this.userGroup);    //getting Valuations depending on userGroup
      }, (error) => {
        console.log("authentication error", error);
      });

  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  getEvaluations(userGroup: any) {

    this.valuationSearchText = "";
    this.searching = false;
    this.isSorting = false;

    switch (userGroup) {
      case "properties":

        this.queryArr.push({ "term": { "id": this.owner_id } });  //to filter the queries by the owners ID

        var ownerId = localStorage.getItem("userId");
        this.valuationService.getAllValuationsByOwnerID(ownerId).subscribe((data) => {
          this.isLoading = false;
          this.propertiesData = data;

          console.log("Property Owner propertiesData: ", this.propertiesData);

          if (this.propertiesData.length == 0) {
            this.isResults = false;
          } else {
            this.isResults = true;
          }
        }, (error) => {
          this.isLoading = false;
          console.log("error getting Valuations", error);
        });

        break;

      case "sponsors":

        this.queryArr = [];

        this.valuationService.getAllValuations().subscribe((data) => {
          this.isLoading = false;
          this.propertiesData = data;
          this.dataSource = new MatTableDataSource(data);

          this.sort.sortChange.subscribe(v => console.log(v))
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'propName': return item.property.propName;
              case 'propDescription': return item.property.propDescription;
              case 'image_url': return item.property.image_url;
              default: return item[property];
            }
          };

          this.dataSource.paginator = this.paginator;

          console.log('this.dataSource');
          console.log("Sponsor propertiesData: ", this.propertiesData);

          if (this.propertiesData.length == 0) {
            this.isResults = false;
          } else {
            this.isResults = true;
          }
        }, (error) => {
          this.isLoading = false;
          console.log("error getting Valuations", error);
        })

        break;
    }
  }

  onView(source: any, state: any) {

    this.viewValuations = false;

    var object = {
      name: source.property.propName,
      description: source.property.propDescription,
      status: source.status
    }

    this.router.navigateByUrl("valuations/" + source.property_id, { state: source });
  }

  closeDialog() {
    this.openSuccessModal = false;
  }

  onValuationSearch() {
    if (this.valuationSearchText.length !== 0) {

      this.searchText = this.valuationSearchText;
      this.isLoading = true;
      var valuationQuery = {};
      if (this.userGroup == "properties") {

        const propertyOwnerQuery = {
          "query": {
            "bool": {
              "must": [
                { "match": { "propName": this.valuationSearchText } }
              ],
              "filter": [
                { "term": { "id": this.owner_id } }
              ]
            }
          }
        }

        valuationQuery = propertyOwnerQuery;

      } else {

        const sponsorQuery = {
          "query": {
            "match": {
              "propName": {
                "query": this.valuationSearchText
              }
            }
          }
        }

        valuationQuery = sponsorQuery;
      }



      this.valuationService.onEvaluationSearch(valuationQuery).subscribe((data) => {

        this.isLoading = false;
        this.searching = true;
        this.isLoading = false;
        var propertyObj = {};

        this.resultsValue = data.hits.total.value;

        if (this.resultsValue > 0) {
          this.propertiesData = [];
          
          this.searchResults = true;
          this.isSorting = true;

          // let dataJsonObj: any = JSON.parse(data);
          // console.log("dataJsonObj", dataJsonObj);


          data.hits.hits.forEach(hit => {
            propertyObj = {
              id: hit._source.id,
              meta: hit._id,
              property: hit._source.property,
              status: hit._source.status,
              property_id: hit._source.property_id
            }
            this.propertiesData.push(propertyObj);
            this.dataSource = this.propertiesData;
          });

          // var stringPropData = JSON.stringify(this.propertiesData["0"]);
          console.log("Elasticsearch Search results", data);
          console.log("Valuation Search results", this.propertiesData);

        } else {
          this.propertiesData = [];
          console.log("Valuation Search results", data.hits.hits);
          this.searchResults = false;
        }



      }, (error) => {
        console.log("Search Error", error);
        this.isLoading = false;

      });
    }

  }

  onChecked(event: any) {

    this.isLoading = true;

    this.createQueryArray(event); // function to create query array this.queryArr

    var sortQuery = {};
    sortQuery = {
      "query": {
        "bool": {
          "filter": this.queryArr
        }
      }
    }

    if (this.queryArr.length === 0) {
      this.isSorting = false;
      console.log("removed all sorting. isSorting: ", this.isSorting);

      this.getEvaluations(this.userGroup);
    } else {

      console.log("elastic sort query", sortQuery);

      this.valuationService.onQuerySearch(sortQuery).subscribe((data) => {
        this.propertiesData = [];
        var propertyObj = {};

        this.isLoading = false;

        console.log("Sorting results", data);
        data.hits.hits.forEach(hit => {
          propertyObj = {
            id: hit._source.id,
            meta: hit._id,
            property: hit._source.property,
            status: hit._source.status,
            property_id: hit._source.property_id,
            sponsor_id: hit._source.sponsor_id
          }
          // this.propertiesData = [];
          this.propertiesData.push(propertyObj);
        });

        if (this.propertiesData.length == 0) {
          this.isResults = false;
        }

        this.isSorting = true;
        this.searching = false;

        console.log("propertiesData: ", this.propertiesData);
      }, (error) => {
        this.isLoading = false;
        console.log("Sorting error", error);
      });

    }



  }

  createQueryArray(event: any): any[] {
    if (!event.target.checked) {
      this.remove(event.target.value);
    } else {
      this.queryArr.push({ "term": { "status": event.target.value } });
      this.filters.push(event.target.value);
    }
    return this.queryArr;
  }

  remove(status: any) {
    if (this.queryArr !== null) {
      var size = this.queryArr.length;
      for (var x = 0; x < size; x++) {
        if (this.queryArr[x].term.status == status) {

          this.queryArr.splice(x, 1);
          console.log("queryArr: ", this.queryArr);

          if (this.queryArr.length == 0) {
            this.isSorting = false;
          }

          break;
        }
      }
    }

    var filterSize = this.filters.length;
    for (var i = 0; i < filterSize; i++) {
      if (this.filters[i] == status) {
        this.filters.splice(i, 1);
        break;
      }
    }

  }

}
